module.exports = __webpack_public_path__ + "static/media/5.051475c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/九宫格未选中态/5.png
// module id = 1623
// module chunks = 0